export default __webpack_public_path__ + "static/media/courses9.1ec36189.svg";